import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/app.js';
import { applyTheme, loadTheme } from './app/preferences.js';
import i18n from './i18n/index.js';
import './styles.css';

document.documentElement.lang = i18n.language;
applyTheme(loadTheme());
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
